var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-5a text-center"},[_c('v-avatar',{attrs:{"color":"red"}},[_c('span',{staticClass:"white--text headline"},[_vm._v(_vm._s(_vm.timer))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }